import { Mountain } from 'lucide-react'

interface HeroProps {
  title: string
  subtitle: string
  description: string
  primaryButtonText?: string
  primaryButtonLink?: string
  secondaryButtonText?: string
  secondaryButtonLink?: string
}

export default function Hero({
  title,
  subtitle,
  description,
}: HeroProps) {
  return (
    <section className="relative overflow-hidden section-padding">
      <div className="absolute inset-0 bg-gradient-to-br from-glacier-100/30 to-glacier-50/50"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=2070')] bg-cover bg-center opacity-10"></div>
      
      <div className="relative container-padding mx-auto max-w-7xl">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center justify-center p-2 bg-glacier-100 rounded-full mb-6">
            <Mountain className="w-6 h-6 text-glacier-600" />
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-glacier-900 mb-4">
            {title}
          </h1>
          
          <div className="inline-block px-4 py-2 bg-glacier-100 rounded-full mb-6">
            <p className="text-glacier-700 font-medium">{subtitle}</p>
          </div>
          
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            {description}
          </p>
          
          <div className="hidden"></div>
        </div>
      </div>
    </section>
  )
}